// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { WorkEntry } = initSchema(schema);

export {
  WorkEntry
};